<ngx-loading-bar [color]="'var(--bs-primary)'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<router-outlet></router-outlet>

<app-toast></app-toast>
